import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-training',
  standalone: true,
  imports: [
    RouterModule,
  ],
  templateUrl: './training.component.html',
  styleUrl: './training.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingComponent {}
